/* Lavender Farm Simulator — Apiary upgrade.
   Each colony card gets a painted hive portrait (healthy or stressed colony artwork chosen from the card's
   own strength reading), bees whose number follows colony strength, and icon-led meters.
   Reads the game's own card markup only; never edits the save. */
(function () {
  'use strict';
  if (window.__gllfSimApiary) return;
  window.__gllfSimApiary = true;
  var BASE = ((document.currentScript && document.currentScript.src) || '').replace(/gllf-sim-apiary\.js.*$/, '');
  function art(id) { return BASE + 'gllf-art-' + id + '.webp'; }
  var ICON = [
    [/strength/i, 'healthy-colony'], [/brood/i, 'brood-frame'], [/honey stores|stores/i, 'honey-jar-set'],
    [/queen/i, 'queen-bee'], [/varroa|mite/i, 'lesson-apiary-frame-inspection'], [/super/i, 'honey-super']
  ];
  function pct(el) { var em = el && el.querySelector('em'); return em ? parseFloat(em.style.width) || 0 : 0; }

  function bees(n) {
    var s = '';
    for (var i = 0; i < n; i++) {
      var d = (-i * 1.3).toFixed(1), r = 26 + (i % 4) * 10, dur = (5 + (i % 3) * 1.7).toFixed(1);
      s += '<g class="gsa-bee" style="animation-delay:' + d + 's;animation-duration:' + dur + 's;--r:' + r + 'px"><ellipse rx="3.2" ry="2.2" fill="#f2b84b" stroke="#2f2936" stroke-width=".8"/><path d="M-1 -2.2 V2.2 M1 -2.2 V2.2" stroke="#2f2936" stroke-width=".7"/><ellipse cx="-.6" cy="-2.8" rx="2" ry="1.3" fill="rgba(255,255,255,.8)"/></g>';
    }
    return s;
  }

  function decorate(card) {
    var meters = card.querySelectorAll('.lfg-apiary-meter');
    var strength = pct(meters[0]);
    var bad = card.querySelector('.lfg-apiary-pill.is-bad, .lfg-apiary-pill.is-warn, .lfg-apiary-pill.is-danger');
    var img = strength < 45 || (bad && strength < 60) ? 'stressed-colony' : 'healthy-colony';
    var nBees = Math.max(1, Math.round(strength / 12));
    var key = img + '|' + nBees;
    var p = card.querySelector(':scope > .gsa-portrait');
    if (!p) {
      p = document.createElement('div');
      p.className = 'gsa-portrait';
      p.setAttribute('aria-hidden', 'true');
      card.insertBefore(p, card.firstChild);
    }
    if (p.getAttribute('data-k') !== key) {
      p.setAttribute('data-k', key);
      p.innerHTML = '<span class="gsa-portrait__sun"></span><img src="' + art(img) + '" alt="" width="384" height="384" loading="lazy" decoding="async">' +
        '<svg class="gsa-portrait__bees" viewBox="-100 -60 200 120" preserveAspectRatio="xMidYMid meet">' + bees(nBees) + '</svg>' +
        '<span class="gsa-portrait__flowers"></span>';
    }
    meters.forEach(function (m) {
      if (m.querySelector('.gsa-ic')) return;
      var label = (m.querySelector('span') || {}).textContent || '';
      var hit = ICON.filter(function (x) { return x[0].test(label); })[0];
      if (!hit) return;
      var ic = document.createElement('img');
      ic.className = 'gsa-ic'; ic.src = art(hit[1]); ic.alt = ''; ic.width = 36; ic.height = 36; ic.loading = 'lazy';
      m.insertBefore(ic, m.firstChild);
      m.classList.add('gsa-meter');
    });
    card.classList.add('gsa-card');
  }

  function banner(view) {
    var head = view.querySelector(':scope > .lfg-page-head');
    if (!head || head.querySelector('.gsa-banner')) return;
    var b = document.createElement('img');
    b.className = 'gsa-banner'; b.src = art('three-hive-apiary'); b.alt = ''; b.setAttribute('aria-hidden', 'true');
    head.classList.add('gsa-head'); head.appendChild(b);
  }

  function tick(root) {
    var view = root.querySelector('section.lfg-view[data-view="apiary"]'); if (!view) return;
    banner(view);
    view.querySelectorAll('.lfg-apiary-hive[data-apiary-hive-card]').forEach(decorate);
  }
  var tries = 0;
  (function wait() {
    var root = document.getElementById('lfg-simulator-root');
    if (!root && document.readyState === 'complete') return;
    if (root && root.querySelector('section.lfg-view[data-view="apiary"]')) {
      tick(root);
      var pending = false;
      new MutationObserver(function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; tick(root); }); }).observe(root.querySelector('section.lfg-view[data-view="apiary"]'), { childList: true, subtree: true });
      return;
    }
    if (++tries < 240) setTimeout(wait, 250);
  })();
})();
